import { Component, ContentChild, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.css'],
})
export class PillComponent implements OnInit {
  @Input() backgroundColour: string = 'bg-gray-200';
  @Input() textColour: string = '';

  @ContentChild('content') contentElement!: Element;

  constructor() {}

  ngOnInit(): void {}
}
